window.WatchAndBuyInit = function (sectionId) {
  var root = document.getElementById('wab-' + sectionId);
  var modal = document.getElementById('wab-modal-' + sectionId);
  if (!root || !modal) return;

  var viewport = root.querySelector('.wab-viewport');
  var track = root.querySelector('.wab-track');
  var cards = Array.prototype.slice.call(root.querySelectorAll('.wab-card')); // originals only
  var prevArrow = root.querySelector('.wab-arrow-prev');
  var nextArrow = root.querySelector('.wab-arrow-next');

  var video = modal.querySelector('.wab-modal-video');
  var closeBtn = modal.querySelector('.wab-modal-close');
  var backdrop = modal.querySelector('.wab-modal-backdrop');
  var muteBtn = modal.querySelector('.wab-mute-btn');
  var iconMuted = modal.querySelector('.wab-icon-muted');
  var iconUnmuted = modal.querySelector('.wab-icon-unmuted');
  var shareBtn = modal.querySelector('.wab-share-btn');
  var shareOverlay = modal.querySelector('.wab-share-overlay');
  var sharePopup = modal.querySelector('.wab-share-popup');
  var shareClose = modal.querySelector('.wab-share-close');
  var shareFacebook = modal.querySelector('.wab-share-facebook');
  var shareWhatsapp = modal.querySelector('.wab-share-whatsapp');
  var sharePinterest = modal.querySelector('.wab-share-pinterest');
  var shareCopyBtn = modal.querySelector('.wab-share-copy');
  var prevBtn = modal.querySelector('.wab-modal-prev');
  var nextBtn = modal.querySelector('.wab-modal-next');
  var productCard = modal.querySelector('.wab-product-card');
  var productAvatar = modal.querySelector('.wab-product-avatar');
  var productVendor = modal.querySelector('.wab-product-vendor');
  var productPrice = modal.querySelector('.wab-product-price');
  var productCompare = modal.querySelector('.wab-product-compare');
  var productDiscount = modal.querySelector('.wab-product-discount');

  var currentIndex = 0;

  function formatMoney(cents) {
    if (!cents) return '';
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return 'PKR ' + amount;
  }

  function openCard(index) {
    var card = cards[index];
    if (!card) return;
    currentIndex = index;

    var videoSrc = card.getAttribute('data-video');
    var poster = card.getAttribute('data-poster');
    var label = card.getAttribute('data-label');
    var price = card.getAttribute('data-price');
    var comparePrice = card.getAttribute('data-compare-price');
    var url = card.getAttribute('data-url');
    var avatar = card.getAttribute('data-avatar');

    if (videoSrc) {
      video.src = videoSrc;
      video.poster = poster || '';
      video.muted = true;
      iconMuted.style.display = '';
      iconUnmuted.style.display = 'none';
      video.play().catch(function () {});
    }

    productVendor.textContent = label || '';
    productAvatar.src = avatar || poster || '';

    if (price) {
      productPrice.textContent = formatMoney(price);
    } else {
      productPrice.textContent = '';
    }

    if (comparePrice && price && parseInt(comparePrice, 10) > parseInt(price, 10)) {
      productCompare.textContent = formatMoney(comparePrice);
      var discount = Math.round((1 - (price / comparePrice)) * 100);
      productDiscount.textContent = '-' + discount + '%';
      productCompare.style.display = '';
      productDiscount.style.display = '';
    } else {
      productCompare.style.display = 'none';
      productDiscount.style.display = 'none';
    }

    productCard.href = url || '#';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    stopAutoplay();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    video.pause();
    video.removeAttribute('src');
    video.load();
    document.body.style.overflow = '';
    closeSharePopup();
    startAutoplay();
  }

  cards.forEach(function (card, index) {
    var btn = card.querySelector('.wab-card-btn');
    btn.addEventListener('click', function () {
      openCard(index);
    });
  });

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') openCard((currentIndex + 1) % cards.length);
    if (e.key === 'ArrowLeft') openCard((currentIndex - 1 + cards.length) % cards.length);
  });

  prevBtn.addEventListener('click', function () {
    openCard((currentIndex - 1 + cards.length) % cards.length);
  });
  nextBtn.addEventListener('click', function () {
    openCard((currentIndex + 1) % cards.length);
  });

  muteBtn.addEventListener('click', function () {
    video.muted = !video.muted;
    iconMuted.style.display = video.muted ? '' : 'none';
    iconUnmuted.style.display = video.muted ? 'none' : '';
  });

  function openSharePopup() {
    var url = productCard.href;
    var title = productVendor.textContent || document.title;

    if (shareFacebook) {
      shareFacebook.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    }
    if (shareWhatsapp) {
      shareWhatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
    }
    if (sharePinterest) {
      sharePinterest.href = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + encodeURIComponent(title);
    }

    shareOverlay.classList.add('is-open');
    sharePopup.classList.add('is-open');
    sharePopup.setAttribute('aria-hidden', 'false');
  }

  function closeSharePopup() {
    shareOverlay.classList.remove('is-open');
    sharePopup.classList.remove('is-open');
    sharePopup.setAttribute('aria-hidden', 'true');
    if (shareCopyBtn) {
      shareCopyBtn.textContent = 'Copy Link';
      shareCopyBtn.classList.remove('is-copied');
    }
  }

  shareBtn.addEventListener('click', openSharePopup);
  if (shareClose) shareClose.addEventListener('click', closeSharePopup);
  if (shareOverlay) shareOverlay.addEventListener('click', closeSharePopup);

  if (shareCopyBtn) {
    shareCopyBtn.addEventListener('click', function () {
      var url = productCard.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          shareCopyBtn.textContent = 'Copied!';
          shareCopyBtn.classList.add('is-copied');
        });
      } else {
        var temp = document.createElement('input');
        temp.value = url;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
        shareCopyBtn.textContent = 'Copied!';
        shareCopyBtn.classList.add('is-copied');
      }
    });
  }

  /* ---------------- Slider (transform-based, no native scroll) ---------------- */

  if (!track || !viewport || !cards.length) return;

  var N = cards.length;
  var loopEnabled = root.getAttribute('data-loop') === 'true';
  var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
  var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;

  var slides = cards;   // full list of .wab-card elements currently in the track (grows if looping)
  var index = 0;        // current position, in units of "slides"
  var cardStep = 0;     // px width of one card + gap
  var autoplayTimer = null;

  function gapSize() {
    var style = getComputedStyle(track);
    var g = parseFloat(style.columnGap || style.gap);
    return isNaN(g) ? 20 : g;
  }

  function measureCardStep() {
    return slides.length ? slides[0].getBoundingClientRect().width + gapSize() : 0;
  }

  function setPosition(newIndex, animate) {
    index = newIndex;
    if (animate === false) {
      track.classList.add('wab-no-transition');
      track.style.transform = 'translateX(' + (-index * cardStep) + 'px)';
      // force reflow so the browser applies the position before we re-enable transitions
      void track.offsetHeight;
      track.classList.remove('wab-no-transition');
    } else {
      track.style.transform = 'translateX(' + (-index * cardStep) + 'px)';
    }
  }

  function maxRealIndex() {
    if (!cardStep) return 0;
    return Math.max(0, Math.round((N * cardStep - viewport.clientWidth) / cardStep));
  }

  function move(delta) {
    var target = index + delta;
    if (!loopEnabled) {
      var max = maxRealIndex();
      target = Math.max(0, Math.min(max, target));
      if (target === index) return;
    }
    setPosition(target, true);
    if (!loopEnabled) updateArrowState();
  }

  function updateArrowState() {
    if (loopEnabled) return;
    var max = maxRealIndex();
    if (prevArrow) prevArrow.disabled = index <= 0;
    if (nextArrow) nextArrow.disabled = index >= max;
  }

  function setupClones() {
    var prependClones = cards.map(function (c) {
      var cl = c.cloneNode(true);
      cl.classList.add('wab-card-clone');
      return cl;
    });
    var appendClones = cards.map(function (c) {
      var cl = c.cloneNode(true);
      cl.classList.add('wab-card-clone');
      return cl;
    });

    var firstReal = track.firstElementChild;
    prependClones.forEach(function (cl) { track.insertBefore(cl, firstReal); });
    appendClones.forEach(function (cl) { track.appendChild(cl); });

    prependClones.concat(appendClones).forEach(function (cl) {
      var idx = parseInt(cl.getAttribute('data-index'), 10);
      var btn = cl.querySelector('.wab-card-btn');
      if (btn) {
        btn.addEventListener('click', function () { openCard(idx); });
      }
    });

    slides = Array.prototype.slice.call(track.querySelectorAll('.wab-card'));
  }

  track.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'transform' || !loopEnabled) return;
    if (index >= 2 * N) {
      setPosition(index - N, false);
    } else if (index < N) {
      setPosition(index + N, false);
    }
  });

  if (loopEnabled) {
    setupClones();
    cardStep = measureCardStep();
    setPosition(N, false);
  } else {
    cardStep = measureCardStep();
    setPosition(0, false);
    updateArrowState();
  }

  window.addEventListener('resize', function () {
    cardStep = measureCardStep();
    setPosition(index, false);
    if (!loopEnabled) updateArrowState();
  });

  if (prevArrow) {
    prevArrow.addEventListener('click', function () { move(-1); });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', function () { move(1); });
  }

  /* ---------------- Autoplay ---------------- */

  function startAutoplay() {
    if (!autoplayEnabled || autoplayTimer) return;
    autoplayTimer = setInterval(function () { move(1); }, autoplaySpeed);
  }
  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  if (autoplayEnabled) {
    startAutoplay();
    viewport.addEventListener('mouseenter', stopAutoplay);
    viewport.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });
  }

  /* ---------------- Touch / drag swipe ---------------- */

  var dragStartX = 0;
  var dragStartTransform = 0;
  var dragging = false;
  var dragMoved = 0;

  function getCurrentTranslateX() {
    var style = getComputedStyle(track);
    var matrix = style.transform;
    if (!matrix || matrix === 'none') return 0;
    var match = matrix.match(/matrix\(([^)]+)\)/);
    if (!match) return 0;
    var parts = match[1].split(',');
    return parseFloat(parts[4]) || 0;
  }

  function dragBounds() {
    // returns [minTransform, maxTransform] — the valid translateX range for the current mode
    if (loopEnabled) {
      return [-(slides.length - 1) * cardStep, 0];
    }
    return [-(maxRealIndex() * cardStep), 0];
  }

  viewport.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    dragging = true;
    dragMoved = 0;
    dragStartX = e.clientX;
    dragStartTransform = getCurrentTranslateX();
    track.classList.add('wab-no-transition');
    stopAutoplay();
  });

  viewport.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var delta = e.clientX - dragStartX;
    dragMoved = delta;

    var bounds = dragBounds();
    var min = bounds[0];
    var max = bounds[1];
    var raw = dragStartTransform + delta;

    // hard clamp with a touch of rubber-band resistance past the edges,
    // so it never reveals blank space beyond the first/last slide
    if (raw > max) {
      raw = max + (raw - max) * 0.25;
    } else if (raw < min) {
      raw = min + (raw - min) * 0.25;
    }

    track.style.transform = 'translateX(' + raw + 'px)';
  });

  function attemptMove(delta) {
    var before = index;
    move(delta);
    if (index === before) {
      setPosition(index, true); // already at the boundary — snap back from any rubber-band overshoot
    }
  }

  function endDrag() {
    if (!dragging) return;
    dragging = false;
    track.classList.remove('wab-no-transition');

    var threshold = cardStep * 0.2;
    if (dragMoved <= -threshold) {
      attemptMove(1);
    } else if (dragMoved >= threshold) {
      attemptMove(-1);
    } else {
      setPosition(index, true); // snap back
    }
    if (autoplayEnabled) startAutoplay();
  }

  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointercancel', endDrag);
  viewport.addEventListener('pointerleave', function () {
    if (dragging) endDrag();
  });
};
